import CardActions from '@material-ui/core/CardActions';
import React from 'react';
import {
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  DisabledInput,
  Edit,
  EditButton,
  Filter,
  List,
  ListButton,
  LongTextInput,
  ReferenceField,
  ReferenceInput,
  Responsive,
  SaveButton,
  SelectInput,
  SimpleForm,
  SimpleList,
  TextField,
  TextInput,
  Toolbar,
} from 'react-admin';

export const SubserviceFilter = props => (
  <Filter {...props}>
    <ReferenceInput label="Market" source="market_id" reference="markets">
      <SelectInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput label="Tnc" source="tnc_id" reference="tncs">
      <SelectInput optionText="display_name" />
    </ReferenceInput>
    <TextInput label="Name" source="name" />
    <TextInput label="Display Name" source="display_name" />
    <BooleanInput label="Active" source="active" />
  </Filter>
);

export const SubserviceList = props => (
  <List {...props} bulkActionButtons={false} filters={<SubserviceFilter />}>
    <Responsive
      small={
        <SimpleList
          primaryText={record => `${record.name}`}
          secondaryText={record => record.display_name}
        />
      }
      medium={
        <Datagrid>
          <EditButton />
          <TextField source="display_name" />
          <ReferenceField label="Market" source="market_id" reference="markets">
            <TextField source="short_name" />
          </ReferenceField>
          <ReferenceField label="Tnc" source="tnc_id" reference="tncs">
            <TextField source="display_name" />
          </ReferenceField>
          <BooleanField source="active" />
          <TextField label="Q sub type" source="queue_submission_type" />
        </Datagrid>
      }
    />
  </List>
);

export const SubserviceCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <ReferenceInput
        label="Market"
        source="market_id"
        reference="markets"
        allowEmpty
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput label="Tnc" source="tnc_id" reference="tncs" allowEmpty>
        <SelectInput optionText="display_name" />
      </ReferenceInput>
      <LongTextInput source="name" />
      <BooleanInput source="active" />
      <LongTextInput source="display_name" />
      <LongTextInput source="logo_url" />
      <LongTextInput source="hex_color" />
      <SelectInput
        label="Queue Submission Type"
        source="queue_submission_type"
        choices={[
          { _id: '', name: '' },
          { _id: 'range', name: 'Range' },
          { _id: 'single', name: 'Single' },
        ]}
        optionText="name"
        optionValue="_id"
      />
    </SimpleForm>
  </Create>
);

const PostEditToolbar = props => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);
export const SubserviceEdit = props => (
  <Edit title={<SubserviceTitle />} actions={<SubserviceActions />} {...props}>
    <SimpleForm toolbar={<PostEditToolbar />}>
      <DisabledInput source="id" />
      <ReferenceInput label="Market" source="market_id" reference="markets">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput label="Tnc" source="tnc_id" reference="tncs">
        <SelectInput optionText="display_name" />
      </ReferenceInput>
      <LongTextInput source="name" />
      <BooleanInput source="active" />
      <LongTextInput source="display_name" />
      <LongTextInput source="logo_url" />
      <LongTextInput source="hex_color" />
      <SelectInput
        label="Queue Submission Type"
        source="queue_submission_type"
        choices={[
          { _id: '', name: '' },
          { _id: 'range', name: 'Range' },
          { _id: 'single', name: 'Single' },
        ]}
        optionText="name"
        optionValue="_id"
      />
    </SimpleForm>
  </Edit>
);

const SubserviceTitle = ({ record }) => {
  return <span>{record ? `"${record.name}"` : ''}</span>;
};

const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
};

const SubserviceActions = ({ basePath, data }) => (
  <CardActions style={cardActionStyle}>
    <ListButton basePath={basePath} />
  </CardActions>
);



// WEBPACK FOOTER //
// ./src/subservices.js